import 'angular';
import 'angular-google-chart';
import 'angular-animate';
import 'angular-cookies';
import 'angular-dragdrop';

import '../../vendor/color-picker/color-picker.min';
import '../../vendor/pg-ng-tooltip/pg-ng-tooltip.min';

import '../../vendor/fullcalendar/fullcalendar';
import '../../vendor/fullcalendar/fullcalendar-columns';
import '../../vendor/calendar/calendar';

// Configs
import { CoreHTTPConfig }                     from './core.http-config';
import { CoreStates }                         from './core.states.ajs';

// Constants
import { PRODUCTTYPES }                       from './constants/core.product-types.constant.ajs';
import { SUBSCRIPTIONKEYS }                   from './constants/core.subscription-keys.constant.ajs';

// Controllers
import { CoreCtrl }                           from './core';
import { CoreSetLoadedCtrl }                  from './core.setLoaded';

// Directives
import { CoreChosenCellDirective }            from './directives/core.chosenCell.directive';
import { CoreClearInputDirective }            from './directives/core.clear-input.directive';
import { CoreCounterDirective }               from './directives/core.counter.directive';
import { CoreCurrencyDirective }              from './directives/core.currency.directive';
import { CoreEmailDirective }                 from './directives/core.email.directive';
import { CoreJobDateDirective }               from './directives/core.job-date.directive';
import { CoreLengthWarningDirective }         from './directives/core.length-warning.directive';
import { CoreNgEnterDirective }               from './directives/core.ng-enter.directive.ajs';
import { CoreNumberDirective }                from './directives/core.number.directive';
import { CorePasswordDirective }              from './directives/core.password.directive';
import { CoreProgressBarDirective }           from './directives/core.progress-bar.directive';
import { CoreQuantityDirective }              from './directives/core.quantity.directive';
import { CoreReorderGridDirective }           from './directives/core.reorderGrid.directive';
import { CoreSaveRouteDirective }             from './directives/core.save-route.directive';
import { CoreSwitchDirective }                from './directives/core.switch.directive';
import { CoreTimeDirective }                  from './directives/core.time.directive';
import { CoreValidatedFormDirective }         from './directives/core.validated-form.directive';

// Runs
import { CoreEventRun }                       from './core.events';
import { CoreRun }                            from './core.run';

angular.module('workshop.core', [
  'colorpicker',
  'googlechart',
  'ngAnimate',
  'ngCookies',
  'ngDragDrop',
  'pg-ng-tooltip',
  'ui.calendar'
])
  .config(CoreHTTPConfig)
  .config(CoreStates)
  .constant('PRODUCTTYPES', PRODUCTTYPES)
  .constant('SUBSCRIPTIONKEYS', SUBSCRIPTIONKEYS)
  .controller('base', CoreCtrl)
  .controller('setLoaded', CoreSetLoadedCtrl)
  .directive('chosenCell', CoreChosenCellDirective)
  .directive('clearInput', CoreClearInputDirective)
  .directive('counter', CoreCounterDirective)
  .directive('currency', CoreCurrencyDirective)
  .directive('email', CoreEmailDirective)
  .directive('jobDate', CoreJobDateDirective)
  .directive('lengthWarning', CoreLengthWarningDirective)
  .directive('ngEnter', CoreNgEnterDirective)
  .directive('number', CoreNumberDirective)
  .directive('password', CorePasswordDirective)
  .directive('progressbar', CoreProgressBarDirective)
  .directive('quantity', CoreQuantityDirective)
  .directive('reorderGrid', CoreReorderGridDirective)
  .directive('saveRoute', CoreSaveRouteDirective)
  .directive('switch', CoreSwitchDirective)
  .directive('time', CoreTimeDirective)
  .directive('validatedForm', CoreValidatedFormDirective)
  .run(CoreEventRun)
  .run(CoreRun);